import { Reveal } from "./Reveal";

const SYMPTOMS = [
  "Anxiety, fear, or emotional overwhelm",
  "Withdrawal or isolation",
  "Confusion or loss of direction",
  "Exhaustion or chronic stress",
  "Insomnia or disrupted sleep",
  "Intense energetic or spiritual experiences",
  "Disconnection from self, others, the world and or your purpose",
  "Difficulty integrating a recent awakening or life-changing experience",
];

export const Symptoms = () => (
  <section
    data-testid="symptoms-section"
    className="bg-ocean text-cream px-6 md:px-12 py-28 md:py-40"
  >
    <div className="max-w-6xl mx-auto">
      <Reveal>
        <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-gold font-medium mb-6">
          You may be experiencing
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-none max-w-3xl">
          There is <span className="italic text-gold">wisdom</span> waiting
          beyond the overwhelm.
        </h2>
      </Reveal>
      <div className="mt-16 md:mt-24 grid md:grid-cols-2 gap-x-16">
        {SYMPTOMS.map((s, i) => (
          <Reveal key={s} delay={0.05 * i} y={24}>
            <div
              data-testid={`symptom-item-${i + 1}`}
              className="flex items-baseline gap-6 py-6 border-t border-cream/15 group"
            >
              <span className="font-serif italic text-gold/80 text-sm w-8 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="text-base md:text-lg text-cream/85 leading-relaxed group-hover:text-cream transition-colors duration-300">
                {s}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-16 font-serif italic text-xl md:text-2xl text-sand/90 max-w-2xl leading-relaxed">
          If you feel overwhelmed, ungrounded, or uncertain how to hold what is
          unfolding, this journey offers a safe, grounded, and compassionate
          space to support you.
        </p>
      </Reveal>
    </div>
  </section>
);
